import { ITextResourceConfigurationService, Disposable, IConfigurationChangeEvent, ClientTypes, IConfigurationService, IPosition,
    IModelService, IModeService, ILifecycleService, LifecyclePhase } from '@workbench-stack/core';
import { Emitter, Event } from '@vscode-alt/monaco-editor/esm/vs/base/common/event';
import { URI } from '@vscode-alt/monaco-editor/esm/vs/base/common/uri';
import { inject, injectable } from 'inversify';
import { Position } from '@vscode-alt/monaco-editor/esm/vs/editor/common/core/position';

@injectable()
export class TextResourceConfigurationService extends Disposable implements ITextResourceConfigurationService {

    private readonly _onDidChangeConfiguration: Emitter<IConfigurationChangeEvent> = this._register(new Emitter<IConfigurationChangeEvent>());
    public readonly onDidChangeConfiguration: Event<IConfigurationChangeEvent> = this._onDidChangeConfiguration.event;

    constructor(
        @inject(ClientTypes.IConfigurationService)
        private readonly configurationService: IConfigurationService,
        @inject(ClientTypes.IModelService)
        private readonly modelService: IModelService,
        @inject(ClientTypes.IModeService)
        private readonly modeService: IModeService,
        @inject(ClientTypes.ILifecycleService)
        private readonly lifecycleService: ILifecycleService,
    ) {
        super();
            this._register(this.configurationService.onDidChangeConfiguration(e => this._onDidChangeConfiguration.fire(e)));
    }

    public getValue<T>(resource: URI, section?: string): T;
    public getValue<T>(resource: URI, at?: IPosition, section?: string): T;
    public getValue<T>(resource: URI, arg2?: any, arg3?: any): T {
        if (typeof arg3 === 'string') {
            return this._getValue(resource, Position.isIPosition(arg2) ? arg2 : null, arg3);
        }
        return this._getValue(resource, null, typeof arg2 === 'string' ? arg2 : undefined);
    }

    private _getValue<T>(resource: URI, position: IPosition | null, section: string | undefined): T {
        const language = resource ? this.getLanguage(resource, position) : undefined;
        if (typeof section === 'undefined') {
            return this.configurationService.getValue<T>({ resource, overrideIdentifier: language });
        }
        return this.configurationService.getValue<T>(section, { resource, overrideIdentifier: language });
    }

    private getLanguage(resource: URI, position: IPosition | null): string | null {
        const model = this.modelService.getModel(resource);
        if (model) {
            return position ? this.modeService.getLanguageIdentifier(model.getLanguageIdAtPosition(position.lineNumber, position.column))!.language : model.getLanguageIdentifier().language;
        }
        return this.modeService.getModeIdByFilepathOrFirstLine(resource);

    }
}
